import { Plan, PlanFeature } from '../dataModels/models';
import { SubscriptionPlanId, resolveCurrentSubscriptionPlanId } from './subscriptionPlans';

type PlanFeatureBusiness = {
  plan?: Pick<Plan, 'planId' | 'features'> | null;
};

export function planHasFeature(
  plan: Pick<Plan, 'planId' | 'features'> | null | undefined,
  feature: PlanFeature,
): boolean {
  return Boolean(plan?.features?.includes(feature));
}

export function businessHasFeature(business: PlanFeatureBusiness | null | undefined, feature: PlanFeature): boolean {
  if (feature === PlanFeature.BOOKING_SUBDOMAIN) {
    return isStandardOrAbove(business);
  }
  if (feature === PlanFeature.MARKETING_CAMPAIGNS || feature === PlanFeature.SMS_NOTIFICATIONS) {
    return resolveCurrentSubscriptionPlanId(business?.plan) === 'plan_premium';
  }
  return planHasFeature(business?.plan, feature);
}

/** Resolve the canonical plan tier for a business. */
export function getBusinessPlanId(business: PlanFeatureBusiness | null | undefined): SubscriptionPlanId {
  return resolveCurrentSubscriptionPlanId(business?.plan);
}

/** Standard or Premium — has appointment deposits and enhanced branding. */
export function isStandardOrAbove(business: PlanFeatureBusiness | null | undefined): boolean {
  const id = getBusinessPlanId(business);
  return id === 'plan_standard' || id === 'plan_premium';
}

/** Premium only — marketing, multi-staff, advanced analytics, branded URL. */
export function isPremium(business: PlanFeatureBusiness | null | undefined): boolean {
  return getBusinessPlanId(business) === 'plan_premium';
}
